import React from 'react';

function Header() {
  return (
    <header className="bg-white shadow-md">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-4">
            <img 
              src="/assets/Header/NAMHS logo clean.png" 
              alt="NAMHS Logo" 
              className="h-12 w-auto"
            />
            <div>
              <h1 className="text-2xl font-bold text-primary-600">
                NAMHS & Partnership Healthplan
              </h1>
              <p className="text-sm text-gray-600">Patient Referral Webpage</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <a href="#locations" className="text-gray-600 hover:text-primary-600">
              Our Locations
            </a>
            <a href="#contact" className="text-gray-600 hover:text-primary-600">
              Contact Us
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header; 